var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnchainFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17096 2.0001C10.5044 0.666635 12.6664 0.666634 13.9999 2.0001C15.3333 3.33356 15.3333 5.49553 13.9999 6.82899L10.8149 10.0139C10.1782 10.6626 9.30739 11.0281 8.39837 11.0281C7.4883 11.0281 6.61654 10.6617 5.97963 10.0117C5.74866 9.77596 5.75252 9.39762 5.98825 9.16665C6.22399 8.93568 6.60233 8.93954 6.8333 9.17527C7.24542 9.59589 7.8095 9.83292 8.39837 9.83292C8.98723 9.83292 9.55131 9.59589 9.96343 9.17527L9.9677 9.17092L9.96772 9.17094L13.1548 5.9839C14.0215 5.11717 14.0215 3.71192 13.1548 2.84519C12.288 1.97846 10.8828 1.97846 10.0161 2.84519L9.61767 3.24357C9.38431 3.47693 9.00595 3.47693 8.77258 3.24357C8.53922 3.0102 8.53922 2.63184 8.77258 2.39848L9.17096 2.0001ZM5.18512 5.98601C5.82184 5.33739 6.69262 4.97194 7.60162 4.97194C8.51168 4.97194 9.38344 5.33825 10.0204 5.9883C10.2513 6.22404 10.2475 6.60238 10.0117 6.83335C9.776 7.06432 9.39765 7.06046 9.16668 6.82472C8.75456 6.40411 8.19048 6.16708 7.60162 6.16708C7.01275 6.16708 6.44867 6.40411 6.03655 6.82472L6.03228 6.82908L6.03226 6.82906L2.84522 10.0161C1.97849 10.8828 1.97849 12.2881 2.84522 13.1548C3.71195 14.0215 5.1172 14.0215 5.98393 13.1548L6.38231 12.7564C6.61568 12.5231 6.99404 12.5231 7.2274 12.7564C7.46077 12.9898 7.46077 13.3682 7.2274 13.6015L6.82902 13.9999C5.49556 15.3334 3.33359 15.3334 2.00013 13.9999C0.666665 12.6664 0.666665 10.5045 2.00013 9.17101L5.18512 5.98601Z",
    fill: "#5E6C84",
    stroke: "#5E6C84",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnchainFilter);
export default __webpack_public_path__ + "static/media/onchainFilter.33767261370ee6474cbdde9500df43d2.svg";
export { ForwardRef as ReactComponent };